/**
 * spaNavigate — client-side navigation for the app's custom (window.location-
 * based) router in App.js.
 *
 * The router reads `window.location.pathname` fresh on every render but does
 * not own a reactive "path" state, so historically components navigated with
 * `window.location.href = ...` which triggers a FULL browser reload (blank
 * white page → app re-bootstrap → logo splash → re-fetch). That flash is what
 * we want to avoid when moving between sections of the same SPA area.
 *
 * This helper pushes a new history entry and dispatches a `popstate` event.
 * App.js listens for `popstate` and bumps a tick state, forcing a re-render
 * that re-evaluates the route from `window.location` — no reload, no flash.
 * Browser Back/Forward then work correctly for these in-app transitions too.
 */
export function spaNavigate(to) {
  if (typeof to !== 'string' || !to) return;
  const current = window.location.pathname + window.location.search + window.location.hash;
  if (to === current) return;
  window.history.pushState({}, '', to);
  window.dispatchEvent(new PopStateEvent('popstate'));
  window.scrollTo(0, 0);
}

/**
 * shouldIntercept — true for a "plain" left-click on an <a> that we want to
 * handle client-side. Returns false for modified clicks (cmd/ctrl/shift/alt),
 * non-primary buttons, or already-handled events so native behaviors like
 * "open in new tab" / middle-click keep working.
 */
export function shouldIntercept(e) {
  return !(
    e.defaultPrevented ||
    e.button !== 0 ||
    e.metaKey ||
    e.ctrlKey ||
    e.shiftKey ||
    e.altKey
  );
}
